'use strict';
var trackingUtils = require('./../utils/tracking.utils');

module.exports = Odigeo.View.extend({
    events: {
        'tap .hotel_post_booking_error_button': 'redirectHotelsWL',
    },

    redirectHotelsWL: function() {
        var clickTracking = this.model.get('buttonTracking');
        trackingUtils.trackEvent('nags', clickTracking);
        Odigeo.trigger(this.widget.id + '-view:specialErrors');
    },

    init: function() {
        this.listenTo(this.model, 'change:errorType', this.renderError);
    },

    renderError: function() {
        var errorType = this.model.get('errorType');
        var pictureType = this.model.get('pictureType');
        var titleKey = errorType.concat('_title');
        var descriptionKey = errorType.concat('_description');
        var buttonKey = errorType.concat('_button');
        var onLoadTracking = this.model.get('onLoadTracking');

        trackingUtils.trackEvent('nags', onLoadTracking);
        this.setTemplate(this.$el, 'error', {
            titleKey: titleKey,
            descriptionKey: descriptionKey,
            buttonKey: buttonKey,
            pictureType: pictureType,
        });
    },
});
